<template>
  <div class="home" ref="bookDetail">
    <div class="header-view">
      {{ title }}
    </div>
    <div class="main-view">
      <div v-html="selectedElementHtml"></div>
      <div v-html="articleElementHtml"></div>
      <!-- <button @click="goPracticeView">Practice</button> -->
      
    </div>
    <div class="tools-view">
      <div class="btns-div" @click="showCatalog">
        <img src="./imgs/catalog.png" alt="" class="tool-img">
      </div>
      <div class="btns-div" @click="showPre">
        <img src="./imgs/leftArrow.png" alt="" class="tool-img">
      </div>
      <div class="btns-div" @click="showNext">
        <img src="./imgs/rightArrow.png" alt="" class="tool-img">
      </div>
      <div class="btns-div" @click="changeFont">
        <img src="./imgs/fontsize.png" alt="" class="tool-img">
      </div>
    </div>
    <div class="font-slider" v-if="showFontsizeChangeTool">
      <el-slider
      v-model="fontSize"
      :step="1"
      :marks="marks"
      :min="0"
      :max="7"
      show-stops>
     </el-slider>
    </div>
    <el-drawer
      title="我是标题"
      :visible.sync="drawer"
      :with-header="false" v-if="textBookInfoVo!=null && textBookInfoVo.unitList!=null">
      <div class="catalog">
        <div class="unit-label" v-for="item,unitIndex in textBookInfoVo.unitList" :key="unitIndex">
          <div class="unit-name" style="font-weight: bold;height: 40px;line-height: 40px;font-size: 18px;">
            {{item.serialName}}&nbsp;&nbsp; {{item.title}}
          </div>
          <div class="lesson-label" v-for="lesson,lessonIndex in item.lessonList" :key="lessonIndex">
            <div class="lesson-name" style="margin-left: 20px;height: 30px;line-height: 30px;font-size: 18px;" @click="gotoDetail(item.id,lesson)">
              {{lesson.serialName}}&nbsp;&nbsp; {{lesson.title}}
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState,mapActions } from "vuex";
// import {Authorization} from '@/util/fly_util.js'
import { loadJS,loadCSS,loadBodyJS,removeAllDetailSource } from "@/utils/wmtools.js"
import axios from 'axios';
import {baseUri, prefix, bookVersion} from '@/utils/cdn.js'
import TextBookApi from "@/api/src/textbook/api/TextBookApi.js";
import TextBookInfoVo from "@/api/src/textbook/model/TextBookInfoVo.js";
const textBookApi = new TextBookApi()

// // let baseUri = "https://cdn.aefree.com/rawdata/online";
// let baseUri = undefined
// // let prefix = '/rawdata/online'
// let prefix = '/fc_sourse/publish'
// let bookVersion = '_v1'
// if(process.env.NODE_ENV != 'development') {
//   baseUri = `http://localhost:8080/books`
//   bookVersion = ''
// }else{
//   baseUri = `https://bookcdn.aefree.com${prefix}`
// }


export default {
  name: 'BookDetail',
  components:{
  },
  data() {
    return {
      sourceFileLoaded: false,
      navTitle: '',
      title:"",
      baseFrameUrl:'',
      textbookId:null,
      unitId:null,
      lessonId:null,
      lessonFile:null,
      filePath:null,
      frameUrl:null,
      selectedElementHtml:"",
      articleElementHtml:"",
      drawer: false,
      lessonList:[],
      currentLessonIndex: -1,
      fontSize: 0,
      textBookInfoVo:null,
      marks: {
        0: '小',
        7: '大'
      },
      showFontsizeChangeTool:false
    }
  },
  computed: {
    
  },
  destroyed(){
    document.body.className = '';
    removeAllDetailSource()
  },
  async mounted() {
    $(document).on('jqueryBridge', (event, data) => {
      console.log(event, data)
      if(data.type == "callSectionDetail") {
        this.callSectionDetail({sectionId: data.data.sectionId})
      }
    })
    try{
      let bodyClassName = window.localStorage.getItem('bodyClassName')
      if(bodyClassName) {
        document.body.className = bodyClassName;
        this.fontSize = parseInt(bodyClassName.replace('font-style', ''))
      }
    }catch(e){

    }
    const {textbookId,unitId,filePath,lessonId,title} = this.$route.params
    this.title = title
    this.textbookId = textbookId
    this.unitId = unitId
    this.filePath = filePath
    this.lessonId = lessonId
    removeAllDetailSource()
    await this.loadInfoData()
    //修改窗口title
    document.title = this.title
    // this.frameUrl = "/rawdata/online/8093380284517515264/7989331510455501330/c01s01.html?Expires=1719976537&OSSAccessKeyId=TMP.3KjQ42hkhHuyD2bhKnPp7pioJKauNDad3ZK9efXJeUDSyTiwY6zp5fX3uPtH3wWPFZxAnX8gNSbACr7feBcq8iUMdpWUek&Signature=0X5akI6AtP02%2FnK%2FizgePh3ZBK4%3D"
    // this.frameUrl = `https://cdn.aefree.com/rawdata/online/${textbookId}/${unitId}/${filePath}`
    // this.frameUrl = `/rawdata/online/${textbookId}/${unitId}/${filePath}`
    let unit = this.textBookInfoVo.unitList.find(unit => {return unit.id == unitId})
    if(this.inDev()) {
      this.frameUrl = `/books/${this.textBookInfoVo.title}/${unit.folderName}/${filePath}`
      this.baseFrameUrl = `${baseUri}/${this.textBookInfoVo.title}/${unit.folderName}/`;
    }else{
      this.frameUrl = `${baseUri}/${textbookId}/${unitId}/${filePath}`
      this.baseFrameUrl = `${baseUri}/${textbookId}/${unitId}/`;
    }
    this.fetchHTMLWithAxios(this.frameUrl)
    
    // console.log(this.frameUrl)
    console.log(this.textBookInfoVo)
  },
  watch: {
    fontSize: function(newVal, oldVal) {
      document.body.className = '';
      var newClass = "font-style"+newVal;
      document.body.className = newClass;
      window.localStorage.setItem('bodyClassName', newClass)
      if(newVal == 0) {
        window.localStorage.removeItem('bodyClassName')
      }
    }
  },
  methods: {
    async loadInfoData() {
      var id = this.textbookId
      let resp = await textBookApi.textBooksInfo(id)
      console.log(resp)
      this.textBookInfoVo = resp
      this.lessonList = this.getLessonList()
      this.currentLessonIndex = this.getCurrentLessonIndex()
    },
    getLessonList(){
      //判断textBookInfoVo中unitList是否为空，如果不为空并且有数据，将unitList中的每一个元素的lessonList取出来判断lessonList是否为空，如果不为空，将lessonList中的每一个元素添加到lessonList中，如果为空，则不添加
      var lessonList = []
      if (this.textBookInfoVo.unitList != null && this.textBookInfoVo.unitList.length > 0) {
        this.textBookInfoVo.unitList.forEach(unit => {
          if (unit.lessonList != null && unit.lessonList.length > 0) {
            unit.lessonList.forEach(lesson => {
              lesson.unitId = unit.id
              lessonList.push(lesson)
            })
          }
        })
      }
      return lessonList
    },
    getCurrentLessonIndex(){
      //从lessonList中获取id为this.lessonId的index 是字符串判断
      return this.lessonList.findIndex(lesson => lesson.id == this.lessonId)
    },

    async fetchHTMLWithAxios(url) {
      // this.loadSource()
      if(!this.sourceFileLoaded) {
        this.loadJsonSource()
        this.sourceFileLoaded = true
      }
      axios.get(url, {
        headers: {
          'textbookId': this.textbookId,
          'Authorization': localStorage.getItem('Authorization'),
        }
      })
      .then(response => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(response.data, 'text/html');
        // const element = doc.querySelector('.fm_unit_horizontal');

        // if (element) {
        //   const images = element.querySelectorAll('img');
        //   images.forEach(image => {
        //     const currentSrc = image.getAttribute('src');
        //     // 构造新的src属性值
        //     const newSrc = `${this.baseFrameUrl}${currentSrc}`;
        //     image.setAttribute('src', newSrc);
        //   });  
        //   this.selectedElementHtml = element.outerHTML;
        //   // console.log(this.selectedElementHtml)
          
        // } else {
        //   console.warn('Element with class "fm_unit_horizontal" not found.');
        // }


        const article = doc.querySelector('body');
        
        if (article) {
          const images = article.querySelectorAll('img');
          images.forEach(image => {
            const currentSrc = image.getAttribute('src');
            const newSrc = `${this.baseFrameUrl}${currentSrc}`;
            image.setAttribute('src', newSrc);
          });  
          this.articleElementHtml = article.outerHTML;
          // console.log(this.articleElementHtml)
        } else {
          console.error('<article> tag not found in the provided HTML string.');
        }
        window.scrollTo({
          top: 0,
          behavior: 'smooth' // 可选，平滑滚动
        });
      })
      .catch(error => {
        console.error('请求失败:', error);
      });
    },

    loadJsonSource(){
      console.log('loadJsonSource')
      let jsonUrl = undefined
      if(this.inDev()) {
        // let unit = this.textBookInfoVo.unitList.find(unit => {return unit.id == unitId})
        // this.frameUrl = `/${this.textBookInfoVo.title}/${unit.folderName}/${filePath}`
        jsonUrl = `/books/${this.textBookInfoVo.title}/META-INF/sourceload.json?t=${new Date().getTime()}`
      }else{
        jsonUrl = `${baseUri}/${this.textbookId}/META-INF/sourceload.json?t=${new Date().getTime()}`
      }
      console.log(jsonUrl)
      var that = this
      axios.get(jsonUrl, {
        headers: {
          'Authorization': localStorage.getItem('Authorization'),
        }
      })
      .then(response => {
        // console.log("loadJsonSource--------");
        // console.log(response.data);
        that.parseCurrentSource(response.data);
      })
      .catch(error => {
        console.error('请求失败:', error);
      });
    },
    parseCurrentSource(jsonData) {
      var textbookId = this.textbookId
      var unitId = this.unitId
      var lessonId = this.lessonId
      // console.log(lessonId)
      // console.log(jsonData.lessons)
      // const lesson = jsonData.lessons.find(l => 
      //   l.lessonid === lessonId && l.fileid === undefined
      // );
      // const lesson = jsonData.lessons[0]

      // console.log(lesson)
      var currentCssList = jsonData.cssList
      var currentJsList = jsonData.jsList

      console.log(currentCssList)
      console.log(currentJsList) 
      let metainfUrl = ``;
      if(this.inDev()) {
        metainfUrl = `${baseUri}/${this.textBookInfoVo.title}/META-INF/`;
      }else{
        metainfUrl = `${baseUri}/${textbookId}/META-INF/`;
      }
      const commonUrl = `${baseUri}/common/`;
      // this.loadCommomCSS()

      for(var i=0;i<currentCssList.length;i++){
        var path = currentCssList[i]
        if(path.indexOf('annotator.css') != -1){
          continue
        }
        //判断是否包含字符串'../META-INF/'
        if(path.indexOf('../META-INF/') != -1){
          path = path.replace('../META-INF/', metainfUrl);
        }
        if(path.indexOf('../../common/') != -1){
          path = path.replace('../../common/', commonUrl);
        }
        
        loadCSS(path,true)
      }

      // this.loadCommomJS()

      //exclude jquery js
      currentJsList = currentJsList.filter(item => {return !item.includes('jquery')})

      for(var i=0;i<currentJsList.length;i++){
        var path = currentJsList[i]
        if(path.indexOf('annotator.js') != -1){
          continue
        }
        // path = path.replace('../../common/', commonUrl);
        if(path.indexOf('../META-INF/') != -1){
          path = path.replace('../META-INF/', metainfUrl);
        }
        if(path.indexOf('../../common/') != -1){
          path = path.replace('../../common/', commonUrl);
        }
        console.log(path)
        loadBodyJS(path,null,true)
      }

    },
    /*
    loadCommomCSS(){
      var cssArr = [
        '../../common/css/base.css',
        '../../common/css/mobile.css',
        // '../../common/css/annotator.css',
        '../../common/css/html5tooltips.animation.css',
        '../../common/css/html5tooltips.css'

      ]
      const absoluteCssUrls = this.toAbsoluteUrls(cssArr, baseUri);
      for (let i = 0; i < absoluteCssUrls.length; i++) {
        loadCSS(absoluteCssUrls[i],true)
      }

    },

    loadCommomJS(){
      
      var jsArr = [
        '../../common/js/dsbridge.js',
        '../../common/js/jquery.min.js',
        // '../../common/js/annotator.js',
        '../../common/js/mark.min.js',
        '../../common/js/html5tooltips.js',
        '../../common/js/global.js',
        '../../common/js/answer.js',
        '../../common/MathJax/MathJax.js?config=MML_HTMLorMML-full'
      ]
      const absolutejsUrls = this.toAbsoluteUrls(jsArr, baseUri);
      for (let i = 0; i < absolutejsUrls.length; i++) {
        loadBodyJS(absolutejsUrls[i], ()=>{
          console.log('loaded')
        },true)
      }
    },*/
    goPracticeView() {
      this.$router.push({name: 'Practice'})
    },
    showCatalog(){
      this.drawer = true
      var elementsCssToRemove = document.querySelectorAll('[id="custInnerCss"]');
      console.log(elementsCssToRemove)
      if(elementsCssToRemove && elementsCssToRemove.length > 0) {
        // 遍历所有找到的元素
        elementsCssToRemove.forEach(function(element) {
          // 移除元素
          if (element.parentNode) {
            element.parentNode.removeChild(element);
          }
        });
      }else{
        let element = document.createElement("style");
        element.setAttribute("type", "text/css");
        element.setAttribute("id","custInnerCss")
        element.innerText = '.h1font {color: blue}'
        document.head.appendChild(element);
      }
    },
    showPre(){
      //如果currentLessonIndex==0 
      if(this.currentLessonIndex==0){
        this.$message.error('已经是第一课了')
      }else{
        
        this.currentLessonIndex = this.currentLessonIndex-1
        var currentLesson = this.lessonList[this.currentLessonIndex]
        var unitId = currentLesson.unitId
        this.gotoDetail(unitId,currentLesson)
      }
    },
    showNext(){
      if(this.currentLessonIndex==this.lessonList.length-1){
        this.$message.error('已经是最后一课了')
      }else{
        
        this.currentLessonIndex = this.currentLessonIndex+1
        var currentLesson = this.lessonList[this.currentLessonIndex]
        var unitId = currentLesson.unitId
        this.gotoDetail(unitId,currentLesson)
      }
    },
    changeFont(){
      this.showFontsizeChangeTool = !this.showFontsizeChangeTool
    },
    gotoDetail(unitid,lesson){
      // removeAllDetailSource()
      console.log(lesson)

      var titleStr = lesson.serialName+" "+lesson.title
      this.title = titleStr
      this.unitId = unitid+""
      this.filePath = lesson.filePath
      this.lessonId = lesson.id+""

      document.title = this.title
      // this.frameUrl = "/rawdata/online/8093380284517515264/7989331510455501330/c01s01.html?Expires=1719976537&OSSAccessKeyId=TMP.3KjQ42hkhHuyD2bhKnPp7pioJKauNDad3ZK9efXJeUDSyTiwY6zp5fX3uPtH3wWPFZxAnX8gNSbACr7feBcq8iUMdpWUek&Signature=0X5akI6AtP02%2FnK%2FizgePh3ZBK4%3D"
      // this.frameUrl = `https://cdn.aefree.com/rawdata/online/${textbookId}/${unitId}/${filePath}`
      // this.frameUrl = `/rawdata/online/${this.textbookId}/${this.unitId}/${this.filePath}`

      // let unit = this.textBookInfoVo.unitList.find(unit => {return unit.id == unitId})
      // if(this.inDev()) {
      //   this.frameUrl = `/books/${this.textBookInfoVo.title}/${unit.folderName}/${filePath}`
      //   this.baseFrameUrl = `${baseUri}/${this.textBookInfoVo.title}/${unit.folderName}/`;
      // }else{
      //   this.frameUrl = `${prefix}/${textbookId}/${unitId}${bookVersion}/${filePath}`
      //   this.baseFrameUrl = `${baseUri}/${textbookId}/${unitId}${bookVersion}/`;
      // }


      if(this.inDev()) {
        let unit = this.textBookInfoVo.unitList.find(unit => {return unit.id == this.unitId})
        this.frameUrl = `/books/${this.textBookInfoVo.title}/${unit.folderName}/${this.filePath}`
        this.baseFrameUrl = `${baseUri}/${this.textBookInfoVo.title}/${unit.folderName}/`;
      }else{
        this.frameUrl = `${prefix}/${this.textbookId}/${this.unitId}/${this.filePath}`
        this.baseFrameUrl = `${baseUri}/${this.textbookId}/${this.unitId}/`;
      }
      this.fetchHTMLWithAxios(this.frameUrl)
      
      // console.log(this.frameUrl)
      console.log(this.textBookInfoVo)
      this.drawer = false
    },
    //meta-inf
    toMetaInfSourceUrls(cssArr, baseUri) {
      const normalizedBaseUri = baseUri.replace('&#39;', "'") + '';

      return cssArr.map(cssPath => {
        // 替换所有'../../'为'/'
        let absolutePath = cssPath.replace(/\.\.\//g, '/');
        absolutePath = absolutePath.replace(/\/\/+/g, '/');
        // 拼接baseUri和处理后的路径
        return normalizedBaseUri + absolutePath;
      });
    },
    //commom
    toAbsoluteUrls(cssArr, baseUri) {
      const normalizedBaseUri = baseUri.replace('&#39;', "'") + '';

      return cssArr.map(cssPath => {
        let absolutePath = cssPath.replace(/\.\.\//g, '/');
        absolutePath = absolutePath.replace(/\/\/+/g, '/');

        // 拼接baseUri和处理后的路径
        return normalizedBaseUri + absolutePath;
      });
    },
    callSectionDetail({sectionId, template}) {
      console.log(sectionId)
      let currentSection = this.textBookInfoVo.unitList.find(unit => {return unit.id == this.unitId}).lessonList.find(lesson => {return lesson.id == this.lessonId}).sectionList.find(section => {return section.id == sectionId})
      console.log(currentSection)
      if(currentSection.type == 1) {
        const { href } = this.$router.resolve({name: 'htmlReading',params:{
          textbookId: this.textbookId,
          unitId: this.unitId,
          filePath: currentSection.filePath,
          lessonId: this.lessonId,
          title: currentSection.title
        }})
        //在新页面打开
        window.open(href)
      }else if(currentSection.type == 2) {
        //打开播放器
      }else if(currentSection.type == 0) {
        const { href } = this.$router.resolve({name: 'Practice',params:{
          id: sectionId,
        }})
        //在新页面打开
        window.open(href)
      }else{
        const { href } = this.$router.resolve({name: 'dialogueDetail',params:{
          sectionId: sectionId,
        }})
        //在新页面打开
        window.open(href)
      }
    },
  },
  
}
</script>

<style lang="less" scoped>

.home{
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 800px;
}

.header-view{
  position: fixed;
  width: 100%;
  height: 60px;
  color: #4a4aff;
  text-align: center;
  font-size: 23px;
  font-weight: 500;
  background: white;
  line-height: 60px;
  border-bottom: 2px solid #f0f0f0;
  z-index: 999;
}

/deep/ .el-main{
    background-color: #F6F6F6;
    color: #333;
    text-align: center;
    padding:0px;
}

.main-view{
  display: flex;
  flex-direction: column;
  width: 60%;/* 增加阅读器宽度原来为50% */
  //background: #ffffff;
  margin-top: 60px;
  border: 1px solid #bcbcbc;/* 给书增加边框线 */ 
  padding-bottom: 90px;
  min-width: 500px;
  .title-view{
    font-weight: 400;
    font-size: 20px;
    color: #191919;
    text-align: left;
    margin-top: 50px;
  }
  .category-list{
    display: flex;
    flex-direction: row;
    font-size: 14px;
    color: #7F7F7F;
    margin-top: 30px;
    .category-name{
      margin-right: 20px;
    }
  }
  .book-list{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 50px;
    padding-left: 10px;
    .book-item{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 15px;
      .image-v{
        display: flex;
        flex-direction: column;
        width: 214px;
        height: 272px;
        background: #F6F8FA;
        border-radius: 6px 6px 6px 6px;
        align-items: center;
        justify-content: center;
        .book-cover{
          width: 158px;
          height: 212px;
        }
      }
      .book-title{
        width: 200px;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        margin-top: 20px;
      }
      .book-price{
        font-weight: bold;
        font-size: 18px;
        color: #72BEFF;
        margin-top: 10px;
      }
    }
  }
}

.pagination{
  margin-top: 50px;
  margin-bottom: 50px;
}

.main-content{
  display: flex;
  flex-direction: column;
  margin-left: 180px;
  margin-right: 180px;
  margin-top: 100px;
  margin-bottom: 100px;
  .l1-title{
    color: #72BEFF;
    font-size: 30px;
    font-weight: bold;
  }
  .l2-title{
    color: #666666;
    font-size: 20px;
    margin-left: 30px;
    font-weight: bold;
  }
  .title-view{
    display: flex;
    flex-direction: row;
    align-items: baseline;
  }
  .text-content{
    font-weight: 400;
    font-size: 15px;
    color: #191919;
    text-align: left;
    line-height: 28px;
    margin-top: 20px;
  }
  .sub-text-content{
    display: flex;
    flex-direction: row;
    .l2-title{
      margin-left: 0px;
      margin-top: 30px;
    }
    .sub-text-content-left{
      flex: 1;
      display: flex;
      flex-direction: column;
      text-align: left;
      margin-right: 60px;
    }
    .sub-text-content-right{
      flex: 1;
      display: flex;
      flex-direction: column;
      text-align: left;
      margin-left: 60px;
      .text-content{
        line-height: 29px;
      }
    }
  }
}



.book{
  display: flex;
  flex-direction: column;
  
  .book-info{
    display: flex;
    flex-direction: row;
    margin-top: 28px;
    .book-cover{
      width: 212px;
      height: 292px;
      border-radius: 0px 0px 0px 0px;
    }
    .info-detail{
      display: flex;
      flex-direction: column;
      flex: 1;
      .name-view{
        display: flex;
        flex-direction: row;
        .book-name{
          font-weight: 400;
          font-size: 22px;
          color: #191919;
          margin-left: 20px;
        }
        .other-book{
          width: 120px;
          height: 34px;
          background: #72BEFF;
          border-radius: 6px 6px 6px 6px;
          line-height: 34px;
          color: white;
          margin-left: auto;
          cursor: default;
        }
      }
      .info-labels{
        display: flex;
        flex-direction: row;
        text-align: left;
        margin-top: 20px;
        .label{
          margin-left: 20px;
          line-height: 30px;
          font-weight: 400;
          font-size: 14px;
          color: #7F7F7F;
        }
      }
    }
    .price-view{
      width: 450px;
      height: 50px;
      margin-top: 10px;
      background: #F2F4F5;
      border-radius: 6px 6px 6px 6px;
      display: flex;
      flex-direction: row;
      margin-left: 20px;
      align-items: center;
      .label{
        font-weight: 400;
        font-size: 14px;
        color: #191919;
        margin-left: 20px;
      }
      .price{
        font-weight: bold;
        font-size: 18px;
        color: #72BEFF;
        margin-left: 10px;
      }
      .buttons-view{
        margin-left: auto;
        margin-right: 10px;
        display: flex;
        flex-direction: row;
        .read-btn{
          width: 80px;
          height: 28px;
          border: 2px solid #72BEFF;
          font-weight: 400;
          font-size: 14px;
          color: #72BEFF;
          line-height: 28px;
          border-radius: 4px;
          cursor: default;
        }
        .buy-btn{
          width: 80px;
          height: 28px;
          margin-left: 10px;
          border: 2px solid #72BEFF;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          line-height: 28px;
          border-radius: 4px;
          background: #72BEFF;
          cursor: default;
        }
      }
    }

  }
  .book-detail{
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    .buttons-view{
      display: flex;
      flex-direction: row;
      font-weight: 400;
      font-size: 16px;
      color: #7F7F7F;
      
      .content-summary{

      }

      .author-info{
        margin-left: 30px;
      }

      .catalog-info{
        margin-left: 30px;
      }

    }
    .content-line{
      background: #F2F4F5;
      height: 1px;
      width: 100%;
      margin-top: 10px;
    }
    .contents{
      width: 100%;
      margin-top: 10px;
      min-height: 400px;
      font-weight: 400;
      font-size: 14px;
      color: #7F7F7F;
      line-height: 36px;
      margin-top: 50px;
      
    }
  }
}
.font-slider{
  position: fixed;
  z-index: 1001;
  bottom: 80px;
  right: 80px;
  width: 150px;
  height: 60px;
  background-color: #c4c4c4;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 10px;
}
.tools-view{
  position: fixed;
  z-index: 1;
  bottom: 150px;
  right: 230px;
  display: flex;
  flex-direction: column;
  .btns-div{
    display: flex;
    flex-direction: column;
    width: 40px;
    height: 40px;
    align-items: center;
    background-color: #c4c4c4;
    justify-content: center;
    border-radius: 20px;
    margin-top: 20px;
  }
  .tool-img{
    width: 20px;
    height: 20px;
  }
}
.catalog{
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  padding-left: 40px;
  padding-right: 40px;
  padding-top:50px;
}
</style>
